import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { graphql } from "gatsby"

const IndexPage = ({ data }) => {
  return (
    <Layout>
      <SEO title="Home" />
      <InstagramPosts {...data.allInstagramContent} />
    </Layout>)
}

const InstagramPosts = ({ nodes }) => {
  return (
    <div className='instagram-posts'>
      {nodes.map((node, idx) => (<InstagramPost key={idx} {...node} />))}
    </div>
  )
}

const InstagramPost = (node) => {

  return (
    <div className='instagram-post'>
      <img
        alt={node.link}
        src={node.images.low_resolution.url}
      />
    </div>
  )
}

export default IndexPage

export const query = graphql`
query MyQuery {
  allInstagramContent {
    nodes {
      id
      link
      images {
        low_resolution {
          url
        }
      }
    }
  }
}
`